export const body = document.body;
export const qs = (s, o = body) => o.querySelector(s);
export const qsa = (s, o = body) => o.querySelectorAll(s);


/**
 * Sets a custom CSS variable to ensure precise vh unit mesuarment
 *
 */

export function setVhProp() {
    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    const vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);
}

export function initVhUnitOverwrite() {
    setVhProp();
    window.addEventListener('resize', setVhProp);
}

export function canUseWebP() {
    const elem = document.createElement('canvas');

    if (elem.getContext && elem.getContext('2d')) {
        // was able or not to get WebP representation
        return elem.toDataURL('image/webp').indexOf('data:image/webp') === 0;
    }

    // very old browser like IE 8, canvas not supported
    return false;
}

/**
     * Add a <link rel={preload | preconnect} ...> to the head
     */
export function addPrefetch(kind, url, as) {
    const linkElem = document.createElement('link');
    linkElem.rel = kind;
    linkElem.href = url;
    if (as) {
        linkElem.as = as;
    }
    linkElem.crossorigin = true;
    document.head.append(linkElem);
}

/**
 * Format number sparated with commas per thousand.
 *
 * @param {Number} num - Number you want to format
 *
 * @returns {string} - Returns the number formatet with commas
 *
 * @example:
 * console.info(formatNumber(2665)) // 2,665
 * console.info(formatNumber(102665)) // 102,665
 * console.info(formatNumber(1240.5)) // 1,240.5
 */

export function formatNumber(num) {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
}

export function isTouch() {
    return 'ontouchstart' in window ? true : false;
}
